<template>
  <modal @modal-close="closed">
    <form
      class="bg-white rounded-lg shadow-lg overflow-hidden w-action"
      @submit.prevent="confirmed"
    >
      <div class="p-8">
        <heading :level="2" class="mb-2">{{ $t('Move Page') }}</heading>
        <p class="mb-6">{{ $t('Please drag and drop pages to reorder') }}</p>

        <Draggable
          v-model="draggablePages"
          type="transition"
          v-bind="dragOptions"
        >
          <div
            v-for="page in draggablePages"
            :key="page.uuid"
            class="cursor-pointer py-2 flex items-center"
          >
            <DragIcon class="mr-2 relative" style="top: -2px" />
            <span
              class="text-90 font-normal leading-normal">{{ page.title || $t('Page Title (optional)') }}</span>
          </div>
        </Draggable>
      </div>

      <div class="bg-30 px-6 py-3 flex">
        <div class="ml-auto">
          <button
            type="button"
            data-testid="cancel-button"
            dusk="cancel-delete-button"
            class="btn text-80 font-normal h-9 px-3 mr-3 btn-link"
            @click.prevent="closed"
          >{{ $t('Cancel') }}
          </button>

          <button
            id="confirm-delete-button"
            ref="confirmButton"
            data-testid="confirm-button"
            type="submit"
            class="btn btn-default btn-primary"
          >{{ $t('Update page order') }}
          </button>
        </div>
      </div>
    </form>
  </modal>
</template>

<script>
  import Draggable from 'vuedraggable';
  import DragIcon from '@/_legacy/views/ChecklistBuilder/Icons/DragIcon';

  export default {
    name: 'ReorderPage',
    components: {
      Draggable,
      DragIcon,
    },
    props: {
      pages: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        draggablePages: this.pages.filter(page => !page.params.header),
      };
    },
    computed: {
      dragOptions() {
        return {
          animation: 200,
          ghostClass: 'opacity-50',
        };
      },
    },
    methods: {
      closed() {
        this.$emit('close');
      },

      confirmed() {
        this.$emit('confirm', this.draggablePages);
      },
    },
  };
</script>
